"use strict";

exports.__esModule = true;
exports.wrap = exports.showReportDialog = exports.setUserContext = exports.setTagsContext = exports.setExtraContext = exports.lastEventId = exports.isSetup = exports.context = exports.captureMessage = exports.captureException = exports.captureBreadcrumb = void 0;
var hasGlobalRaven = typeof window !== 'undefined' && window.Raven != null;
var captureException = exports.captureException = function captureException(err, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return hasGlobalRaven ? window.Raven.captureException(err, opts) : undefined;
};
var captureMessage = exports.captureMessage = function captureMessage(msg, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return hasGlobalRaven ? window.Raven.captureMessage(msg, opts) : undefined;
};
var context = exports.context = function context(fn, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return hasGlobalRaven ? window.Raven.context(opts, fn) : fn();
};
var wrap = exports.wrap = function wrap(fn, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return hasGlobalRaven ? window.Raven.wrap(opts, fn) : fn;
};
var setUserContext = exports.setUserContext = function setUserContext(ctx) {
  return hasGlobalRaven ? window.Raven.setUserContext(ctx) : undefined;
};
var setTagsContext = exports.setTagsContext = function setTagsContext(ctx) {
  return hasGlobalRaven ? window.Raven.setTagsContext(ctx) : undefined;
};
var setExtraContext = exports.setExtraContext = function setExtraContext(ctx) {
  return hasGlobalRaven ? window.Raven.setExtraContext(ctx) : undefined;
};
var captureBreadcrumb = exports.captureBreadcrumb = function captureBreadcrumb(breadcrumb) {
  return hasGlobalRaven ? window.Raven.captureBreadcrumb(breadcrumb) : undefined;
};
var lastEventId = exports.lastEventId = function lastEventId() {
  return hasGlobalRaven ? window.Raven.lastEventId() : undefined;
};
var showReportDialog = exports.showReportDialog = function showReportDialog(opts) {
  return hasGlobalRaven ? window.Raven.showReportDialog(opts) : undefined;
};
var isSetup = exports.isSetup = function isSetup() {
  return hasGlobalRaven ? window.Raven.isSetup() : false;
};